import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { PdfAssets } from './pdfTemplates';
import { createReportTemplate as createModularReportTemplate } from './pdf';
import type { ReportPdfData } from './pdf/types';

/**
 * Creates a document definition for the MetaRouter report PDF
 * This is a wrapper around the modular implementation in src/utils/pdf/index.ts
 * @param data Report data for the PDF
 * @param diagramImageBase64 Base64 encoded image of the diagram
 * @param assets Logo and font assets for the PDF
 * @returns PDF document definition
 */
export const createReportTemplate = (
  data: ReportPdfData,
  diagramImageBase64?: string,
  assets?: PdfAssets
): TDocumentDefinitions => {
  return createModularReportTemplate(data, diagramImageBase64, assets);
};

// Re-export the ReportPdfData interface for backward compatibility
export type { ReportPdfData } from './pdf/types';
